import type { IProject } from '@/types';

const getProjectFromJson = async (
  jsonUrl: string
): Promise<IProject | null> => {
  try {
    const projectResponse = await fetch(jsonUrl);
    const project = await projectResponse.json();

    return project;
  } catch {
    return null;
  }
};

export { getProjectFromJson };
